export default __webpack_public_path__ + "static/makers-bg-9f8d460fb21b615a2083677cb37d4a72.webp";